export class CancellationReasonDTO {
    constructor(
        public id: string,
        public displayName: string,
        public orderIndex: number,
        public dateCreated: string,
        public dateUpdated: string,
        public isPublic: boolean = true
    ) { }
}
